import React, { useCallback } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unblockUser } from "../../../apis/chatApi";
import { useChatBlockUsersLoad } from "../../../hooks/useChatBlockUsersLoad";
import { blockedUsersQueryKey } from "../../../hooks/useChatBlockUsersLoad";
import BackHeader from "../../shared/BackHeader/BackHeader";
import Toast from "../../shared/Toast/Toast";
import BlockedUserList from "../BlockedUserList/BlockedUserList";
import styles from "./BlockedUsersPage.module.scss";

/**
 * 차단 사용자 관리 페이지 (01_CHAT 0.0.6 - Figma MCP 40004311:94070, 95190)
 */
function BlockedUsersPage({
  className = "",
  title = "",
  items = [],
  onBack,
  setBlockedUserLoads,
  setUnblockToast,
  toastMessage,
  children,
}) {
  const hasItems = items.length > 0;
  const qc = useQueryClient();

  const handleBlockUsersLoaded = useCallback(
    (list) => setBlockedUserLoads(list),
    [setBlockedUserLoads]
  );
  useChatBlockUsersLoad(handleBlockUsersLoaded, null);

  const unblockMutation = useMutation({
    mutationFn: (item) => unblockUser(item.user_id),
    onSuccess: (res, item) => {
      const name = item.name ?? "대표명";
      if (res?.success !== false) {
        setUnblockToast?.(name);
        qc.invalidateQueries({ queryKey: blockedUsersQueryKey });
        qc.setQueryData(["blockStatus", item.user_id], (prev) => ({
          ...(prev || {}),
          blockedByMe: false,
        }));
      } else {
        setUnblockToast?.(res?.message ?? `${name}님 차단 해제에 실패했습니다.`);
      }
    },
    onError: (_, item) => {
      setUnblockToast?.(`${item.name ?? "대표명"}님 차단 해제에 실패했습니다.`);
    },
  });

  const handleUnblock = useCallback(
    (item) => unblockMutation.mutate(item),
    [unblockMutation]
  );

  return (
    <div
      className={`${styles.root} ${className}`.trim()}
      data-name="Mobile"
      data-node-id="40004311:94070"
    >
      <div className={styles.panel} data-name="Messages Panel" data-node-id="40004311:94071">
        <BackHeader
          title={title}
          type="main"
          onBackClick={onBack}
        />
        <div className={styles.divider} data-node-id="40004311:94095" />
        <div className={styles.content}>
          {hasItems ? (
            <BlockedUserList items={items} onUnblock={handleUnblock} />
          ) : (
            (children ?? <div className={styles.empty}>차단한 사용자가 없습니다.</div>)
          )}
        </div>
      </div>
      <Toast
        message={toastMessage ? `'${toastMessage}'님 차단이 해제되었습니다.` : null}
        data-node-id="40004311:95225"
      />
    </div>
  );
}

export default BlockedUsersPage;
